export enum DueDate {
  Overdue = 1,
  DueWithin30Days = -30,
  DueWithin60Days = -60,
  DueWithin120Days = -120,
  DueWithinYear = -365
}
